module.exports = __webpack_public_path__ + "media/bootstrap-icons/eject-fill-f63bd426.svg";